import React, { type PropsWithChildren, useCallback, useRef } from 'react';

import EditingStateContext, { type EditingStateContextType } from './EditingStateContext';

const EditingStateProvider: React.FC<PropsWithChildren> = ({ children }) => {
  // Use a Set to track currently editing fields for O(1) lookup
  const editingFieldsRef = useRef<Set<string>>(new Set());

  const isFieldBeingEdited = useCallback<EditingStateContextType['isFieldBeingEdited']>(
    (fieldKey: string): boolean => editingFieldsRef.current.has(fieldKey),
    [],
  );

  const setFieldEditingState = useCallback<EditingStateContextType['setFieldEditingState']>(
    (fieldKey: string, isEditing: boolean): void => {
      if (isEditing) {
        editingFieldsRef.current.add(fieldKey);
      } else {
        editingFieldsRef.current.delete(fieldKey);
      }
    },
    [],
  );

  const value: EditingStateContextType = {
    isFieldBeingEdited,
    setFieldEditingState,
  };

  return <EditingStateContext.Provider value={value}>{children}</EditingStateContext.Provider>;
};

export default EditingStateProvider;
